import { GridItemData, GridItemMovedEvent } from 'vue-grid-layout'
import { Includes } from '@/types/common.type'

export interface ConfigurationRelationshipStep<Option extends object, Relationship extends object> extends GridItemData {
    item: Relationship & Includes<Relationship, Option>
}

export interface ConfigurationRelationshipStepMoved<Relationship extends object> extends GridItemMovedEvent {
    item?: Relationship
}

export interface ConfigurationRelationshipsStepsState<Option extends object, Relationship extends object & Includes<Relationship, Option>, Step extends ConfigurationRelationshipStep<Option, Relationship>> {
    option: Option
}
export const initialConfigurationRelationshipsStepsState =
    (): ConfigurationRelationshipsStepsState<any, any, any> => ({
        option: null
    })
